import { CesiumTerrainProvider, IonResource } from 'cesium';
import { createContext, use, ReactNode } from 'react';
import { ConfigService } from 'app/config/config.service';

export const TerrainProviderContext = createContext<CesiumTerrainProvider | null>(null);

const CESIUM_WORLD_TERRAIN_ASSET_ID = 1;

const providerPromise = CesiumTerrainProvider.fromUrl(
    IonResource.fromAssetId(CESIUM_WORLD_TERRAIN_ASSET_ID, {
        accessToken: ConfigService.cesiumIonApiKey,
    }),
    {
        requestWaterMask: false,
        requestVertexNormals: ConfigService.enableTerrainOverlays,
    },
);

export const TerrainProviderContextProvider = ({ children }: { children: ReactNode }) => {
    const provider = use(providerPromise);
    return (
        <TerrainProviderContext.Provider value={provider}>
            {children}
        </TerrainProviderContext.Provider>
    );
};
